export const getProductNameColor = (index) => {
  if (index % 3 === 0) {
    return '#fdd38a';
  }

  if (index % 3 === 1) {
    return '#92dbe1';
  }

  return '#fd9595';
}

export const getProductRowColor = (index) => {
  if (index % 3 === 0) {
    return '#fbedd5';
  }

  if (index % 3 === 1) {
    return '#d7f0f2';
  }

  return '#fbd8d8';
}

export const formatNumber = value => {
  const fixedValue = Math.abs(value).toFixed(2);
  const isNegative = Number(value) < 0;

  return `${isNegative ? '-' : ''}$${fixedValue}`;
}


// WEBPACK FOOTER //
// ./src/api/PerformanceFeedback.js